import { useQueryClient } from '@tanstack/react-query'
import { api } from '../http'
import { buildJsonApiParams } from '../jsonApi'
import { queryKeys } from '../queryKeys'
import { useApiQuery, useApiMutation } from './_base'

/** GET /ruleGroups */
export function useRuleGroupList(params = {}, options = {}) {
    const apiParams = buildJsonApiParams(params)
    return useApiQuery({
        queryKey: queryKeys.ruleGroups.list(apiParams),
        url: '/ruleGroups',
        params: apiParams,
        options,
    })
}

/** GET /ruleGroups/{id} */
export function useRuleGroup(id, params = {}, options = {}) {
    const apiParams = buildJsonApiParams(params)
    return useApiQuery({
        queryKey: queryKeys.ruleGroups.detail(id, apiParams),
        url: `/ruleGroups/${id}`,
        params: apiParams,
        options: { enabled: !!id, ...options },
    })
}

/** POST /ruleGroups */
export function useCreateRuleGroup() {
    const qc = useQueryClient()
    return useApiMutation({
        mutationKey: ['ruleGroups', 'create'],
        mutationFn: (payload) => api.post('/ruleGroups', {}, payload),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: queryKeys.ruleGroups.all })
        },
    })
}

/** PUT /ruleGroups/{id} */
export function useUpdateRuleGroup() {
    const qc = useQueryClient()
    return useApiMutation({
        mutationKey: ['ruleGroups', 'update'],
        mutationFn: ({ id, ...payload }) =>
            api.put(`/ruleGroups/${id}`, {}, payload),
        onSuccess: (_d, { id }) => {
            qc.invalidateQueries({
                queryKey: queryKeys.ruleGroups.detail(id),
            })
            qc.invalidateQueries({ queryKey: queryKeys.ruleGroups.lists() })
            qc.invalidateQueries({ queryKey: queryKeys.rules.all })
        },
    })
}

/** DELETE /ruleGroups/{id} */
export function useDeleteRuleGroup() {
    const qc = useQueryClient()
    return useApiMutation({
        mutationKey: ['ruleGroups', 'delete'],
        mutationFn: (id) => api.delete(`/ruleGroups/${id}`),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: queryKeys.ruleGroups.all })
            qc.invalidateQueries({ queryKey: queryKeys.rules.all })
        },
    })
}
